module.exports = __webpack_public_path__ + "img/aDonkiKong_350x350.4c5afba7.jpg";